import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StoredPaymentCard } from '@/redux/payment/paymentCardsStore';

interface PaymentCardState {
  data: StoredPaymentCard[] | null;
}

const initialState: PaymentCardState = {
  data: null,
};

export const paymentCardSlice = createSlice({
  name: 'paymentCard',
  initialState,
  reducers: {
    createPaymentCards: (state, action: PayloadAction<StoredPaymentCard[]>) => {
      state.data = action.payload;
    },
    deletePaymentCards: (state) => {
      state.data = initialState.data;
    },
  },
});

export const { createPaymentCards, deletePaymentCards } = paymentCardSlice.actions;

export default paymentCardSlice.reducer;
